module.exports = __webpack_public_path__ + "img/kachel-ZAHNMUND_MICROSILVERKAUGUMMI.ae592540.png";